// src/vehicleManager.js

// class to maintain vehicle configuration

import { vehicleCatalogues } from '../data/vehicle-cat-shared.js';

class VehicleManager {
   constructor(catKey, _hasCustom = false) {
      this.activeVehicleIndex = 0;
      9;
      this.activeVehicleGroupIndex = 0;
      this.vehicleRecords = {};
      this.hasCustom = _hasCustom;
      this.isLoaded = false;

      // Setup paths based on the requested catalogue name
      if (!vehicleCatalogues[catKey]) {
         console.log('Invalid category key');
         throw new Error(`Invalid category key: ${catKey}`);
      }
      this.groups = vehicleCatalogues[catKey].entries;
      this.vehiclesUri = vehicleCatalogues[catKey].apiUri;
      this.imgPath = vehicleCatalogues[catKey].imgPath;
   }

   initVehicles(customEntries, callback) {
      // get all of vehicles from api and trigger callback on completion.
      $.get(this.vehiclesUri, (d) => {
         this.vehicleRecords = d;
         let customVehicles = [];
         if (Array.isArray(customEntries)) {
            this.hasCustom = true;
            customVehicles = customVehicles.concat(customEntries);
         }
         this.vehicleRecords['-1'] = customVehicles; // Index -1 for custom group
         this.isLoaded = true;
         if (typeof callback === 'function') {
            callback();
         }
      }).fail((jqXHR, textStatus, errorThrown) => {
         console.error(errorThrown);
      });
   }

   getVehicleGroups() {
      if (this.hasCustom) this.groups.push({ index: -1, name: 'Custom', drive_axles: 2 });
      return this.groups;
   }

   setVehicleGroup(index) {
      this.activeVehicleGroupIndex = Number(index);
      this.activeVehicleIndex = 0;
      return this.activeVehicleGroupIndex;
   }

   getActiveVehicleGroup() {
      const indexValue = this.activeVehicleGroupIndex;
      let group = this.groups.find((group) => group.index === indexValue);
      return group;
   }

   getActiveGroupVehicles() {
      const group = this.getActiveVehicleGroup();

      let vehicles;
      if (group) vehicles = this.vehicleRecords[`${group.index}`];
      else {
         console.error('Invalid vehicle group:', this.activeVehicleGroupIndex);
         return [];
      }
      if (vehicles) {
         return vehicles;
      } else {
         console.error('Vehicles could not be loaded:', this.activeVehicleGroupIndex);
         return [];
      }
   }
   getActiveGroupVehicleNames() {
      const vehicles = this.getActiveGroupVehicles();

      // Generate descriptions for the dropdown to select a vehicle
      let vehicleNames = [];
      for (let i = 0; i < vehicles.length; i++) {
         let name = '';
         const apprv = vehicles[i].approved || '';
         // Check if 'approved' contains a level, e.g., "Level 2"
         const match = typeof apprv === 'string' ? apprv.match(/Level (\d+)/) : null; // see if it is a vehicle with a level and add the level
         let categoryStr = '';
         if (vehicles[i].category) categoryStr = `Cat ${vehicles[i].category} -`;
         if (match) {
            const lvl = match[1];
            name = `${categoryStr} (L${lvl}) - ${vehicles[i].description}`;
         } else {
            name = `${categoryStr} ${vehicles[i].description}`;
         }
         vehicleNames.push(name);
      }
      return vehicleNames;
   }

   getActiveVehicle() {
      const vehicles = this.getActiveGroupVehicles();
      const vehicle = vehicles[this.activeVehicleIndex];
      return vehicle;
   }

   setActiveVehicle(index) {
      this.activeVehicleIndex = Number(index);
      return this.activeVehicleIndex;
   }

   getImagePath() {
      const group = this.getActiveVehicleGroup();
      const groupPath = group ? group.imageGroupPath : 'custom/'; // e.g prime-mover
      return this.imgPath + groupPath;
   }

   getIsLoaded() {
      return this.isLoaded;
   }
}

export { VehicleManager };
